// LessonPlanner One serves production assets from lessonplannerone.com.
// Legacy BOPPPS Lesson Planner asset URLs remain application-owned so imported
// JSON presentations can resolve equivalent files on the new domain. In local
// development, known app-owned assets are routed through the CRA dev proxy.
export const CURRENT_APP_HOST = 'lessonplannerone.com';
export const CURRENT_APP_HOSTS = [CURRENT_APP_HOST, `www.${CURRENT_APP_HOST}`];
export const LEGACY_APP_HOSTS = ['bopppslessonplanner.com', 'www.bopppslessonplanner.com'];
export const KNOWN_APP_HOSTS = [...CURRENT_APP_HOSTS, ...LEGACY_APP_HOSTS];

export const isKnownAppHost = (hostname = '') => KNOWN_APP_HOSTS.includes(String(hostname).toLowerCase());

export const toFetchableUrl = (src) => {
    try {
        if (typeof window === 'undefined') return src;
        const url = new URL(src, window.location.href);
        if (!/^https?:$/.test(url.protocol) || !isKnownAppHost(url.hostname)) return src;
        const appPath = `${url.pathname}${url.search}`;
        if (isKnownAppHost(window.location.hostname)) {
            return appPath;
        }
        return `/remote-assets${appPath}`;
    } catch {
        return src;
    }
};
